// extracted by mini-css-extract-plugin
export var mainImage = "tirePage-module--mainImage--9-WI0";